export const getIdentityNameParts = (name: unknown): { firstName: string; lastName: string } => {
  if (typeof name === 'string') {
    const normalizedName = name.trim();
    const [firstName = '', ...lastNameParts] = normalizedName.split(/\s+/);
    return { firstName, lastName: lastNameParts.join(' ') };
  }

  if (typeof name === 'object' && name !== null) {
    const nameRecord = name as Record<string, unknown>;
    return {
      firstName: typeof nameRecord.first === 'string' ? nameRecord.first.trim() : '',
      lastName: typeof nameRecord.last === 'string' ? nameRecord.last.trim() : '',
    };
  }

  return { firstName: '', lastName: '' };
};
